import { Map } from 'immutable';

const currentYear = new Date().getFullYear();
export default Map({
  regionName: '77-Москва',
  endYear: '',
  endMonth: '',
  startYear: currentYear,
  startMonth: '',
  privilegePeriodType: 1,
  taxationObjectName: '',
  taxType: '',
  taxInspectionCode: '',
  otherTaxationObjectName: '',
  privilegeDocument: '',
  attachedDocument: [],
});
